<p-menu
class="custom-css"
[appendTo]="appendTo"
#menu
[model]="items" 
[popup]="true">
</p-menu> 